module.exports = __webpack_public_path__ + "static/media/hero-image-mobile.f149151c.webp";